import useInfiniteScroll from "react-infinite-scroll-hook";
import SimpleSpinner from "../../loader";
import EmptyData from "../../common/EmptyData";
import CardView from "./cardView";
import { GetImages } from "../../../utils/GetImages";

const MainScrollView = (dataHookState) => {
  const loadMoreRecords = () => {
    if (!dataHookState.loading && dataHookState.hasMore) {
      dataHookState.fetchData(dataHookState.currentPage + 1);
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading: dataHookState.loading,
    hasNextPage: dataHookState.hasMore, // This can be dynamic based on your API response
    onLoadMore: loadMoreRecords,
    disabled: !dataHookState.hasMore,
    rootMargin: "0px 0px 100px 0px", // Adjust root margin as per your requirement
  });

  return (
    <>
      <div className="infinite-scroll-container">
        {dataHookState?.rows?.length == 0 && !dataHookState.loading ? (
          <EmptyData
            mainText={"No Service Requests Found"}
            subText={undefined}
            button={undefined}
            ImageSrc={GetImages.NoServiceReqFound}
          />
        ) : (
          <>
            {dataHookState?.rows?.map((item, i) => {
              return <CardView item={item} isAddress={true} />;
            })}
            {(dataHookState.loading || dataHookState.hasMore) && (
              <div ref={sentryRef} className="loading-trigger">
                {dataHookState.loading && (
                  <SimpleSpinner
                    myClassName={dataHookState?.rows?.length === 0 ? "Icon50" : "Icon40"}
                  />
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default MainScrollView;
